export { getProductServerAction } from 'next-flight-server-reference-proxy-loader?id=40ad97542d3bbc9231a29420d80d0c7f346ce22194&name=getProductServerAction!'